import { useMemo } from 'react';
import { useAppSelector } from 'app/hooks';
import { getOperationalTableViewUrl } from 'util/urls';
import { isCropPlanIntegrationEnabled, isOperationalTableViewEnabled } from 'user/selectors';
import { useCropPlanStash } from './useCropPlanStash';

export const useRedirectUrl = () => {
  const [cropPlan] = useCropPlanStash();
  const isCropPlanIntegration = useAppSelector(isCropPlanIntegrationEnabled);
  const isOperationalTableView = useAppSelector(isOperationalTableViewEnabled);

  const redirectUrl = useMemo(() => {
    if (isCropPlanIntegration && cropPlan?.redirectUrl) {
      return cropPlan.redirectUrl;
    }

    if (isOperationalTableView) {
      return getOperationalTableViewUrl();
    }

    return null;
  }, [isCropPlanIntegration, cropPlan, isOperationalTableView]);

  return redirectUrl;
};
